import { OpsPromptsLayoutComponent } from 'app/components/ops-prompts/OpsPromptsLayoutComponent'

export const handle = {
  title: `Prompts`,
  breadcrumb: `Prompts`,
}

export default function OpsPromptsLayout(): React.ReactElement {
  return <OpsPromptsLayoutComponent />
}
